document.querySelectorAll('.faq-accordion-header').forEach(button => {
  button.addEventListener('click', function() {
    const accordion = this.parentElement;
    const content = this.nextElementSibling;

    // Close all other accordion items
    document.querySelectorAll('.faq-accordion-item').forEach(item => {
      if (item !== accordion) {
        item.classList.remove('active');
        item.querySelector('.faq-accordion-content').style.display = 'none';
      }
    });

    // Toggle current item
    const isActive = accordion.classList.contains('active');
    accordion.classList.toggle('active');
    content.style.display = isActive ? 'none' : 'block';
  });
});


